"use client";

import React, { useEffect, useRef, useState } from "react";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";

import "@/components/SegmentedControl/SegmentedControl.css";
import { BaseEntry, SegmentedControlTab, TargetSite } from "@/types";

import DynamicImport from "../dynamicImport";

interface SegmentedControlProps {
  entry: {
    tabs: SegmentedControlTab[];
  };
}

const SegmentedControl: React.FC<SegmentedControlProps> = ({ entry }) => {
  const [tabIndex, setTabIndex] = useState(0);

  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    controlTabPanelIntoViewport(tabIndex);
  }, [tabIndex]);

  function controlTabPanelIntoViewport(index: number) {
    const panels = ref.current?.querySelectorAll("[role='tabpanel'");
    if (panels?.length && panels.length >= 0) {
      const panelBounding = panels.item(index)?.getBoundingClientRect();
      if (panelBounding && panelBounding.top < 50) {
        window.scrollBy({ behavior: "instant", top: panelBounding.top - 50 });
      }
    }
  }
  return (
    <div className="segmented-control flex flex-col py-xl" ref={ref}>
      <Tabs onSelect={(i) => setTabIndex(i)}>
        <div className="tab-list-container w-full overflow-x-auto no-scrollbar sticky top-0 bg-white z-20 md:top-[var(--header-height)]">
          <TabList className={"tab-list m-auto flex w-fit"}>
            {entry.tabs.map((item, index) => (
              <Tab
                key={`tab-${index}`}
                type="button"
                className={"relative py-m px-s font-secondary text-gray-30 text-center text-nowrap tab focus-within:outline-0 cursor-pointer"}
                selectedClassName="text-black-0/100 tab-active"
                onFocus={(e) => e.currentTarget.scrollIntoView({ inline: "center", behavior: "smooth", block: "nearest" })}
              >
                {item.label}
              </Tab>
            ))}
          </TabList>
        </div>
        {entry.tabs.map((item, index) => {
          return (
            <TabPanel key={`tab-${index}`} className={"bg-gray-7"}>
              <div className="flex flex-col">
                <DynamicImport components={[...item.components]} target={TargetSite.corporate} />
              </div>
            </TabPanel>
          );
        })}
      </Tabs>
    </div>
  );
};
export default SegmentedControl;
